import React, { createContext, useContext } from "react"

import type { SuperSearchConfig } from "./types"

const SuperSearchContext = createContext<SuperSearchConfig | undefined>(
  undefined,
)

type Props = {
  config: SuperSearchConfig
  children: React.ReactNode
}

export const SuperSearchProvider = ({ config, children }: Props) => {
  return (
    <SuperSearchContext.Provider value={config}>
      {children}
    </SuperSearchContext.Provider>
  )
}

export const useSuperSearchConfig = (): SuperSearchConfig => {
  const context = useContext(SuperSearchContext)
  if (!context) {
    throw new Error(
      "useSuperSearchConfig must be used within a SuperSearchProvider",
    )
  }

  return context
}
